import { createFileRoute, notFound } from "@tanstack/react-router";
import E2ETeammatesHarness from "@/pages/E2ETeammatesHarness";

export const Route = createFileRoute("/e2e/teammates-panel/")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound();
  },
  component: E2ETeammatesHarness,
});
